// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"20afd787","453":"74abc4f6","455":"47be2f71","644":"0dac82e7"}[chunkId] + ".chunk.js";
};